import { render, staticRenderFns } from "./shortcutIcons.vue?vue&type=template&id=508aa648"
import script from "./shortcutIcons.vue?vue&type=script&lang=js"
export * from "./shortcutIcons.vue?vue&type=script&lang=js"
import style0 from "./shortcutIcons.vue?vue&type=style&index=0&id=508aa648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports